import { useDataContext } from 'context/data-context'
import { AmazonIcon } from './amazon'
import { AppStoreIcon } from './app-store'
import { GooglePlayIcon } from './google-play'
import { LGIcon } from './lg'
import { Container } from './styled'

export const DownloadButtons = () => {
  const { strings } = useDataContext()

  return (
    <Container>
      {!!strings.download_app_store && (
        <a href={strings.download_app_store} target="_blank" rel="noreferrer">
          <AppStoreIcon />
        </a>
      )}
      {!!strings.download_google_play && (
        <a href={strings.download_google_play} target="_blank" rel="noreferrer">
          <GooglePlayIcon />
        </a>
      )}
      {!!strings.download_amazon && (
        <a href={strings.download_amazon} target="_blank" rel="noreferrer">
          <AmazonIcon />
        </a>
      )}
      {!!strings.download_lg && (
        <a href={strings.download_lg} target="_blank" rel="noreferrer">
          <LGIcon />
        </a>
      )}
      {strings.download_samsung_visible === 'TRUE' && (
        <span>Также ищи VotVot на Samsung TV</span>
      )}
    </Container>
  )
}
